<template>
    <div class="search-panel">
        <div class="search-panel__mask" v-if="toggle" @click="cancel"></div>
        <div :class="['search-panel__body card', toggle ? 'active' : '']">
            <slot></slot>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['toggle'],
        methods: {
            cancel () {
                this.$emit('cancel')
            }
        }
    }
</script>


<style lang="less" scoped>
    .search-panel {
        .search-panel__mask {
            position: fixed;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: #000;
            opacity: .75;
            transition: all .2s ease;
            z-index: 99;
        }
        .search-panel__body {
            padding: 15px;
            border-top-left-radius: 4px;
            border-top-right-radius: 4px;
            background: #fff;
            height: 70vh;
            bottom: -70vh;
            transition: all .2s ease;
            z-index: 100;
            position: fixed;
            left: 0;
            width: 100%;
            box-sizing: border-box;
            &.active {
                bottom: 0;
            }
        }
    }
</style>

